// extracted by mini-css-extract-plugin
export default {"book":"Book_book__LM2fK"};